import React from "react";
import { observer } from "mobx-react";
import { OrbitComponent } from "../../base-components/orbit-component/orbit-component";
import { action, observable, runInAction, makeObservable } from "mobx";
import { BurnoutAnimation } from "./burnout-animation.component";
import { AnimationDismissType, FAB_DISAPPEAR_DURATION_IN_SECONDS } from "./burnout-animation-constants";
import { BurnoutFab } from "./boxes/burnout-fab.box";
import {ISendElasticEventOptions} from "../../../services/analytics/analytics.service.interface";
import {DisposableBurnoutAnimationDependencies} from "./disposable-burnout-dependencies";

interface IBurnoutAnimationWrapper {
    checkOmg(): boolean;
    showOmg?(): void;
    paused?: boolean;
    onSafeUnmountNotice?(): void;
}

@observer
export class BurnoutAnimationWrapper extends OrbitComponent<IBurnoutAnimationWrapper> {

    constructor(props: IBurnoutAnimationWrapper) {
        super(props);

        makeObservable(this);
    }

    @observable.ref
    private _showButton = false;
    @observable.ref
    private _animationEnded = false;
    @observable.ref
    private _removeButtonAnimation = false;
    private disposableDependencies: DisposableBurnoutAnimationDependencies = new DisposableBurnoutAnimationDependencies();

    componentWillUnmount() {
        super.componentWillUnmount();
        this.disposableDependencies.dispose();
    }


    private getExitAnimation = () => {
        if (this.props.checkOmg()) {
            return AnimationDismissType.FloatingButton;
        } else {
            return AnimationDismissType.FadeOut;
        }
    }

    @action.bound
    private onExitAnimationEnd = () => {
        if (this.props.checkOmg()) {
            this._showButton = true;
        } else {
            this.disposableDependencies.setTimeout(() => {
                this.recheckOmg(true);
            }, 2000);
        }
        this._animationEnded = true;
    };

    @action.bound
    private recheckOmg = (retryOnFail: boolean) => {
        if (this.props.checkOmg()) {
            this._showButton = true;
        } else {
            if (retryOnFail) {
                this.disposableDependencies.setTimeout(() => {
                    this.recheckOmg(false);
                }, 2000);
            } else {
                // we can safely unmount this component
                this.props.onSafeUnmountNotice && this.props.onSafeUnmountNotice();
            }
        }
    };

    @action.bound
    private onClickFAB = () => {
        let data: ISendElasticEventOptions = {
            eventType: "Orbit_Marketing",
            category: 'Burnout',
            action: 'Click_floating_icon'
        }
        this.services.analytics.sendElasticInfoEvent(data, true);

        if (this.props.showOmg) {
            this.props.showOmg();
        }
        this._removeButtonAnimation = true;
        this.disposableDependencies.setTimeout(() => {
            runInAction(() => {
                this._showButton = false;
                // we can safely unmount this component
                this.props.onSafeUnmountNotice && this.props.onSafeUnmountNotice();
            });
        }, FAB_DISAPPEAR_DURATION_IN_SECONDS * 1000 + 500);
    };

    private _onMountFAB = () => {
        let data: ISendElasticEventOptions = {
            eventType: "Orbit_Marketing",
            category: 'Burnout',
            action: 'View_floating_icon'
        }
        this.services.analytics.sendElasticInfoEvent(data, true);
    };

    private _renderFAB = (zIndex: number) => {
        if (this._showButton) {
            return (
                <BurnoutFab
                    zIndex={zIndex}
                    onClick={this.onClickFAB}
                    onMount={this._onMountFAB}
                    removeButton={this._removeButtonAnimation}
                />
            )
        }
        return null;
    };


    render() {
        const zIndex = this.services.burnoutService.getBurnoutAnimationZIndex();
        /* Show the animation. If the prize is in bonus money and the omg was already received, the animation transform itself into a button.
        Else, the animation dissapear and I use another element as a button because
        it is a lot of logic inside the animation component that we don't need anymore and it might break stuff  */
        return this._animationEnded ? this._renderFAB(zIndex) : <BurnoutAnimation
            getExitAnimation={this.getExitAnimation}
            onExitAnimationEnd={this.onExitAnimationEnd}
            zIndex={zIndex}
            paused={this.props.paused}
        />;
    }
}
